import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import MyModal from 'components/modals/modal';
import Select from '../select/select';
import useApplyFiltersModal from './apply-filters-modal-hooks';
import MultiSelect from '../select/multi-select';
import ApplyButton from './components/apply-button';
import ResetFiltersButton from './components/reset-filters-button';

export default function ApplyFiltersModal({
  open,
  setOpen,
  filtersToEnable,
  applyFilters,
}) {
  const {
    //sales rep input field state
    salesRep,
    setSalesRep,

    //price group input field state
    priceGroup,
    setPriceGroup,

    //payment terms input field state
    paymentTerms,
    setPaymentTerms,

    //shipping method input field state
    shippingMethod,
    setShippingMethod,

    //sort by input field state
    sortBy,
    setSortBy,

    //show retailers filter input field state
    showRetailersAndBuyersWith,
    setShowRetailersAndBuyersWith,

    //groups input field state
    groups,
    setGroups,

    //currency input field state
    currency,
    setCurrency,

    //show buyers filter input field state
    showBuyers,
    setShowBuyers,

    //function to handle apply filters and reset filters actions
    handleSubmit,

    supportData, //select field options
  } = useApplyFiltersModal({
    applyFilters,
    setOpen,
    open,
  });

  return (
    <MyModal
      open={open}
      setOpen={setOpen}
      size='small'
      title='Apply Filters'
      showCloseIcon
      actions={[
        <ResetFiltersButton key='1' handleSubmit={handleSubmit} />,
        <ApplyButton key='2' handleSubmit={handleSubmit} />,
      ]}
      sx={{ width: '1030px' }}
    >
      <Grid container columnSpacing={2}>
        {/*
        
        sales rep filter 
        
        */}
        {filtersToEnable?.salesRep ? (
          <Grid item xs={12} sm={4}>
            <MultiSelect
              label='Sales Rep'
              labelAccessor='name'
              placeholder='Select Sales Rep'
              value={salesRep}
              valueAccessor='id'
              setValue={setSalesRep}
              options={supportData?.sales_rep}
              sx={{ marginBottom: '15px' }}
            />
          </Grid>
        ) : null}

        {/*
        
        price group filter 
        
        */}
        {filtersToEnable?.priceGroup ? (
          <Grid item xs={12} sm={4}>
            <MultiSelect
              label='Price Group'
              labelAccessor='name'
              placeholder='Select Price Group'
              value={priceGroup}
              valueAccessor='id'
              setValue={setPriceGroup}
              options={supportData?.price_groups}
              sx={{ marginBottom: '15px' }}
            />
          </Grid>
        ) : null}

        {/*
        
        payment terms filter 
        
        */}
        {filtersToEnable?.paymentTerms ? (
          <Grid item xs={12} sm={4}>
            <MultiSelect
              label='Payment Terms'
              labelAccessor='name'
              placeholder='Select Payment Terms'
              value={paymentTerms}
              valueAccessor='id'
              setValue={setPaymentTerms}
              options={supportData?.payment_method}
              sx={{ marginBottom: '15px' }}
            />
          </Grid>
        ) : null}

        {/*
        
       shipping method filter 
        
        */}
        {filtersToEnable?.shippingMethod ? (
          <Grid item xs={12} sm={4}>
            <MultiSelect
              label='Shipping Method'
              labelAccessor='name'
              placeholder='Select Shipping Method'
              value={shippingMethod}
              valueAccessor='id'
              setValue={setShippingMethod}
              options={supportData?.shipping_method}
              sx={{ marginBottom: '15px' }}
            />
          </Grid>
        ) : null}

        {/*
        
        groups filter 
        
        */}
        {filtersToEnable?.groups ? (
          <Grid item xs={12} sm={4}>
            <MultiSelect
              label='Groups'
              labelAccessor='name'
              placeholder='Select Groups'
              value={groups}
              valueAccessor='id'
              setValue={setGroups}
              options={supportData?.groups}
              sx={{ marginBottom: '15px' }}
            />
          </Grid>
        ) : null}

        {/*
        
        currency filter 
        
        */}
        {filtersToEnable?.currency ? (
          <Grid item xs={12} sm={4}>
            <MultiSelect
              label='Currency'
              labelAccessor='name'
              placeholder='Select Currency'
              value={currency}
              valueAccessor='id'
              setValue={setCurrency}
              options={supportData?.client_currency}
              sx={{ marginBottom: '15px' }}
            />
          </Grid>
        ) : null}

        {/*
        
        sort by filter 
        
        */}
        {filtersToEnable?.sortBy ? (
          <Grid item xs={12} sm={4}>
            <Select
              label='Sort By'
              placeholder='Select Sort By'
              value={sortBy}
              setValue={setSortBy}
              options={[
                { label: 'Albphabetically', value: 'alphabetically' },
                { label: 'Recently Created', value: 'recentlyCreated' },
                { label: 'Recently Updated', value: 'recentlyUpdated' },
              ]}
              sx={{ marginBottom: '15px' }}
            />
          </Grid>
        ) : null}

        {/*
        
        show retailers  filter 
        
        */}
        {filtersToEnable?.showRetailersAndBuyersWith ? (
          <Grid item xs={12} sm={4}>
            <Select
              label='Show Retailers & Buyers with'
              labelAccessor='label'
              valueAccessor='value'
              value={showRetailersAndBuyersWith}
              placeholder='Select Show Retailers & Buyers With'
              setValue={setShowRetailersAndBuyersWith}
              options={[
                {
                  label: 'Retailers with no buyers',
                  value: '2',
                },
                {
                  label: 'Buyers with no email address',
                  value: '3',
                },
                {
                  label: 'Buyers with email address',
                  value: '4',
                },
                {
                  label: 'Retailers with no orders',
                  value: '5',
                },
                {
                  label: 'Retailers with orders',
                  value: '6',
                },
              ]}
              sx={{ marginBottom: '15px' }}
            />
          </Grid>
        ) : null}

        {/*
        
        show buyers filter 
        
        */}
        {filtersToEnable?.showBuyers ? (
          <Grid item xs={12} sm={4}>
            <MultiSelect
              label='Show Buyers'
              labelAccessor='name'
              value={showBuyers}
              placeholder='Select Show Buyers'
              valueAccessor='id'
              setValue={setShowBuyers}
              options={supportData?.showBuyers}
              sx={{ marginBottom: '15px' }}
            />
          </Grid>
        ) : null}
      </Grid>
    </MyModal>
  );
}

ApplyFiltersModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  filtersToEnable: PropTypes.object.isRequired,
  applyFilters: PropTypes.func.isRequired,
};
